import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextBox from '../controls/TextBox';
import CircularProgress from '../CircularProgress';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import { validateEmail } from 'utils';
import { showMessage, handleHTTPError } from 'store/actions';
import { createPartner } from 'apis';
import './index.scss';

class AddNewPartnerModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            phoneNumber: '',
            password: '',
            confirmPassword: '',
            validate: false,
            loading: false,
        };
    }

    create = async () => {
        if (this.state.loading) return;
        this.setState({ validate: true });
        const { name, email, phoneNumber, password, confirmPassword } = this.state;
        if (!name || !email || !password || !confirmPassword || !validateEmail(email) || password !== confirmPassword)
            return;
        try {
            this.setState({ loading: true });
            await createPartner({ name, email, phoneNumber, password });
            this.cancel();
            this.props.callback();
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    cancel = () => {
        this.props.toggle();
        this.setState({
            name: '',
            email: '',
            phoneNumber: '',
            password: '',
            confirmPassword: '',
            validate: false,
            loading: false,
        });
    };

    render() {
        const { name, email, phoneNumber, password, confirmPassword, loading, validate } = this.state;

        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                className={this.props.className}
                id="new-partner-modal"
            >
                <ModalHeader toggle={this.props.toggle} className=" position-relative">
                    Add New Partner
                    {loading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '30px',
                                right: '60px',
                            }}
                        >
                            <CircularProgress size={10} />
                        </div>
                    )}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <TextBox
                            label="Name"
                            id="name"
                            name="name"
                            className="col-12 mb-3"
                            type="text"
                            validate={validate}
                            value={name}
                            required
                            placeholder="iPlayme2"
                            onBlur={(e) => {}}
                            onChange={(name, e) => {
                                this.setState({ name });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Email Address"
                            id="email"
                            name="email"
                            className="col-md-6 mb-3"
                            type="text"
                            validate={validate}
                            value={email}
                            required
                            placeholder="partner@mail.com"
                            onBlur={(e) => {}}
                            onChange={(email, e) => {
                                this.setState({ email });
                            }}
                            validationOption={{
                                showMsg: false,
                                reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Phone Number"
                            id="phoneNumber"
                            name="phoneNumber"
                            className="col-md-6 mb-3"
                            type="text"
                            validate={validate}
                            value={phoneNumber}
                            placeholder="partner@mail.com"
                            onBlur={(e) => {}}
                            onChange={(phoneNumber, e) => {
                                this.setState({ phoneNumber });
                            }}
                            validationOption={{
                                type: 'number',
                                numberType: 'int',
                                showMsg: false,
                                check: false,
                                required: false,
                            }}
                        />
                        <TextBox
                            label="Password"
                            id="password"
                            name="password"
                            type="password"
                            className="col-md-6 mb-3"
                            validate={validate}
                            required
                            value={password}
                            placeholder="Password"
                            onBlur={(e) => {}}
                            onChange={(password, e) => {
                                this.setState({ password });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Confirm Password"
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            className="col-md-6 mb-3"
                            validate={validate}
                            value={confirmPassword}
                            required
                            placeholder="Password"
                            onBlur={(e) => {}}
                            onChange={(confirmPassword, e) => {
                                this.setState({ confirmPassword });
                            }}
                            validationOption={{
                                showMsg: false,
                                compare: password,
                                check: true,
                                required: true,
                            }}
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.cancel}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={this.create} disabled={loading}>
                        Add
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = ({ user }) => {
    const { systemSettings } = user;
    return { systemSettings };
};

export default connect(mapStateToProps, {
    showMessage,
    handleHTTPError,
})(AddNewPartnerModal);
